import {Action} from '@ngrx/store';

export const SET_AUTH = '[APPCONFIG] SET AUTH';
export const SET_APP_VERSION = '[APPCONFIG] SET APP VRESION';
export const LOAD_INVOICE = 'LOAD INVOICE';

export class SetAppVersion implements Action {
    readonly type = SET_APP_VERSION;
    constructor(public payload?: string) { }
}

export class SetAuth implements Action {
    readonly type = SET_AUTH;
    constructor(public payload?: boolean) { }
}

export class SetLoadInvoice implements Action {
    readonly type = LOAD_INVOICE;
    constructor(public payload?: boolean) { }
}

export type All = SetAppVersion | SetAuth | SetLoadInvoice;



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/reducers/appconfig.actions.ts